import "./NotificationBellButton.css";

/**
 * Compact bell-icon button for in-app notifications.
 * Shows a numeric badge for unread count (capped at 99+) and supports
 * `aria-expanded` so it can drive a dropdown/sheet.
 */
function NotificationBellButton({
  unreadCount = 0,
  open = false,
  onClick,
  title = "Notifications",
}) {
  const count = Math.max(0, Number(unreadCount) || 0);
  const badge = count > 99 ? "99+" : String(count);
  return (
    <button
      type="button"
      className={`notif-bell${open ? " notif-bell--open" : ""}${
        count > 0 ? " notif-bell--has-unread" : ""
      }`}
      onClick={onClick}
      aria-expanded={open}
      aria-label={count > 0 ? `${title} — ${count} unread` : title}
      title={title}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
      </svg>
      {count > 0 ? <span className="notif-bell__badge">{badge}</span> : null}
    </button>
  );
}

export default NotificationBellButton;
